module.exports = __webpack_public_path__ + "img/Guyana.7b4d539f.png";